/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateActivityRequest
 */
export interface UpdateActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateActivityRequest
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateActivityRequest
     */
    summary?: string;
    /**
     * Must not be greater than 255 characters.
     * @type {string}
     * @memberof UpdateActivityRequest
     */
    locationName?: string | null;
    /**
     * Must be between -90 and 90.
     * @type {number}
     * @memberof UpdateActivityRequest
     */
    lat?: number | null;
    /**
     * Must be between -180 and 180.
     * @type {number}
     * @memberof UpdateActivityRequest
     */
    lng?: number | null;
    /**
     * Must be a valid date.
     * @type {string}
     * @memberof UpdateActivityRequest
     */
    scheduledAt?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateActivityRequest
     */
    isPublic?: boolean;
}

/**
 * Check if a given object implements the UpdateActivityRequest interface.
 */
export function instanceOfUpdateActivityRequest(value: object): value is UpdateActivityRequest {
    return true;
}

export function UpdateActivityRequestFromJSON(json: any): UpdateActivityRequest {
    return UpdateActivityRequestFromJSONTyped(json, false);
}

export function UpdateActivityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateActivityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'locationName': json['location_name'] == null ? undefined : json['location_name'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'scheduledAt': json['scheduled_at'] == null ? undefined : json['scheduled_at'],
        'isPublic': json['is_public'] == null ? undefined : json['is_public'],
    };
}

export function UpdateActivityRequestToJSON(json: any): UpdateActivityRequest {
    return UpdateActivityRequestToJSONTyped(json, false);
}

export function UpdateActivityRequestToJSONTyped(value?: UpdateActivityRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'summary': value['summary'],
        'location_name': value['locationName'],
        'lat': value['lat'],
        'lng': value['lng'],
        'scheduled_at': value['scheduledAt'],
        'is_public': value['isPublic'],
    };
}

